// Cart badge auto-update
declare const origin_ajax: { ajax_url: string; nonce: string };

const badges = document.querySelectorAll<HTMLElement>(".js-cart-count");

function updateBadge(count: number) {
    badges.forEach(badge => {
        badge.textContent = String(count);
        if (count === 0) {
            badge.classList.add("is-hidden");
        } else {
            badge.classList.remove("is-hidden");
        }
    });
}

function fetchCartCount() {
    fetch(`${origin_ajax.ajax_url}?action=smj_cart_count`)
        .then(res => res.json())
        .then(response => {
            if (response.success) {
                updateBadge(response.data.count);
            }
        })
        .catch(() => {});
}

// Listen for WooCommerce AJAX add-to-cart events (jQuery triggers)
document.body.addEventListener("added_to_cart", () => {
    fetchCartCount();
});

// Also listen via jQuery if available (WooCommerce uses jQuery events)
if (typeof (window as any).jQuery !== "undefined") {
    (window as any).jQuery(document.body).on(
        "added_to_cart removed_from_cart updated_cart_totals updated_wc_div",
        () => {
            fetchCartCount();
        }
    );
}

// Hide badge on load if count is 0
document.addEventListener("DOMContentLoaded", () => {
    badges.forEach(badge => {
        const count = parseInt(badge.textContent || "0", 10);
        if (count === 0) {
            badge.classList.add("is-hidden");
        }
    });
});
